import React from 'react';
import { Text } from '@goodfynd/ui';

import { GoodfyndSitesStatusPage } from './GoodfyndSitesStatusPage';

import classes from './GoodfyndSitesStatusPage.module.css';

export function GoodfyndSites404() {
  return (
    <GoodfyndSitesStatusPage
      description="The page you are trying to visit no longer exists or the link is incorrect."
      title="This page is not available."
      // action={{
      //   external: true,
      //   href: 'https://goodfynd.com/vendors',
      //   label: 'Discover vendors on Goodfynd',
      // }}
    >
      <Text align="center" className={classes.support}>
        Need a hand? Reach out to&nbsp;
        <a className={classes.supportLink} href="mailto:support@goodfynd.com">
          support@goodfynd.com
        </a>
        .
      </Text>
    </GoodfyndSitesStatusPage>
  );
}
